import { apiClient } from "@/lib/api-client";
import { VideoInterviewData } from "../dto/videoInterviewDto";

export const GetVideoInterviewData = async (token: string): Promise<VideoInterviewData> => {
    try {
        const response = await apiClient.get<VideoInterviewData>(`/interview/public/${token}`);
        return response.data;
    } catch (error: unknown) {
        if (error && typeof error === 'object' && 'structuredError' in error) {
            const err = error as { structuredError: { message?: string } };
            throw new Error(err.structuredError.message || "Failed to load interview");
        }
        throw error;
    }
};

export const UploadInterviewVideo = async (token: string, videoBlob: Blob, captchaToken: string = ""): Promise<boolean> => {
    const formData = new FormData();
    formData.append('file', videoBlob, 'interview.webm');
    formData.append('captchaToken', captchaToken);

    try {
        await apiClient.post(`/interview/public/${token}/video`, formData);
        return true;
    } catch (error: unknown) {
        if (error && typeof error === 'object' && 'structuredError' in error) {
            const err = error as { structuredError: { message?: string } };
            throw new Error(err.structuredError.message || "Failed to upload video");
        }
        throw error;
    }
};
